import React, { useState, useEffect } from 'react';
import { Box, Button, Slide, Grid } from '@mui/material';
import ContactFormWrapper from '../components/ContactFormWrapper';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { useLocation } from 'react-router-dom';

const ContactPage = () => {
  const { t } = useTranslation();
  const location = useLocation();

  // Läs in ev. ?reason=other från URL
  const params = new URLSearchParams(location.search);
  const reasonFromUrl = params.get('reason');

  const [selectedOption, setSelectedOption] = useState<null | 'services' | 'other'>(null);

  // Om någon skickas via länk (t.ex. från footer)
  useEffect(() => {
    if (reasonFromUrl === 'other') {
      setSelectedOption('other');
    } else if (reasonFromUrl === 'services') {
      setSelectedOption('services');
    }
  }, [reasonFromUrl]);

  const handleReset = () => setSelectedOption(null);

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <Box sx={{ px: 3, py: 5, maxWidth: '900px', mx: 'auto' }}>
        {/* Val-knappar */}
        {!selectedOption && (
          <Grid container spacing={2} justifyContent="center" mt={2} mb={4}>
            <Grid item>
              <Button
                variant="contained"
                onClick={() => setSelectedOption('services')}
                sx={{
                  backgroundColor: '#c6a04c',
                  color: '#000',
                  px: 4,
                  '&:hover': { backgroundColor: '#d1ae5a' }
                }}
              >
                {t('contactpage.optionServices')}
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                onClick={() => setSelectedOption('other')}
                sx={{
                  backgroundColor: '#c6a04c',
                  color: '#000',
                  px: 4,
                  '&:hover': { backgroundColor: '#d1ae5a' }
                }}
              >
                {t('contactpage.optionOther')}
              </Button>
            </Grid>
          </Grid>
        )}

        {/* Formulär för tjänster */}
        <Slide direction="left" in={selectedOption === 'services'} mountOnEnter unmountOnExit>
          <Box>
            <ContactFormWrapper
              type="full"
              pageName={t("contactpage.pageLabel")}
              hideFields={['startDate', 'services', 'employees', 'businessStatus', 'previousSystem']}
              showHeader={false}
            />
          </Box>
        </Slide>

        {/* Formulär för övriga frågor */}
        <Slide direction="right" in={selectedOption === 'other'} mountOnEnter unmountOnExit>
          <Box>
            <ContactFormWrapper
              type="simple"
              pageName={t("contactpage.pageLabel")}
              showHeader={false}
            />
          </Box>
        </Slide>

        {/* Tillbaka-knapp */}
        {selectedOption && (
          <Box textAlign="center" mt={4}>
            <Button
              onClick={handleReset}
              variant="outlined"
              sx={{
                borderColor: '#c6a04c',
                color: '#c6a04c',
                '&:hover': {
                  borderColor: '#d1ae5a',
                  backgroundColor: '#f9f4eb'
                }
              }}
            >
              ⬅ {t('contactpage.back')}
            </Button>
          </Box>
        )}
      </Box>
    </motion.div>
  );
};

export default ContactPage;
